const mediaQuery = (type = 'max', measure = 'width', bp, thenFunc = function () { }, elseFunc = function () { }) => {

    if (matchMedia) {
      const mq = window.matchMedia('('+type+'-'+measure+': '+bp+'px)');
      mq.addListener(WidthChange);
      WidthChange(mq);
    }
  
    function WidthChange(mq) {
      if (mq.matches) {
        thenFunc();
      }else{
        elseFunc();
      }
    }
  
  }
  
  module.exports = {
    mediaQuery: mediaQuery
  }


// WEBPACK FOOTER //
// ./js/utils/media-query.js